import useSWRImmutable from 'swr/immutable';
import urlResolver from 'admin/utils/URLResolver';
import Waffle from 'edrolo/utils/Waffle';
import { getter } from 'core/utils';

export const useActivity = (activityId) => {
  const { data: activity, error: activityError } = useSWRImmutable(
    urlResolver.reverse('api:activities:object', { activityId }),
    getter
  );

  // hardcode enable_collaborators to false
  // we specifically want this disabled for all courses
  if (activity && Waffle.switch_is_active('disable_activity_collaboration')) {
    activity.enable_collaborators = false;
  }

  return {
    data: activity,
    error: activityError,
    loading: !activityError && !activity,
  };
};
